import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Menu, MenuItem, Fade, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import videojs from "video.js";
import "video.js/dist/video-js.css";
// import styles from "../create-feedback/CreateFeedback.module.scss"; // REMOVED SCSS
import "videojs-markers/dist/videojs.markers.css";
import "videojs-markers";
import { useDispatch, useSelector } from "react-redux";
import { getCoachFeedback } from "../../../redux/network/coachAPI";
import { Stage, Layer, Rect } from "react-konva";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from 'react-router-dom';
import {
  isStarted_GetFetchVideoContent,
  error_GetFetchVideoContent,
  success_GetFetchVideoContent,
} from "../../../redux/reducers/videoSlice";
import { getFetchGamePostFileThumbnail } from "../../../redux/network/videoApi";
import { GET_POST_CONTENT, GET_INDIVIDUAL_REPORT } from "../../../config/endpoints";
import FeedbackList from "../componnets/FeedbackList";
import AnnotationStage from "../componnets/Annotations";
import VideoPlayer from "../componnets/VideojsPlayer";
import GameVideoDetails from '../../GamePost/GameVideoDetails/GameVideoDetails';
import CoachClosingFeedback from "../componnets/CoachClosingFeedback";
import TagHelper from '../../../helpers/PostHelpers/TagHelper';
import { Download } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faVideo,
  faBolt
} from "@fortawesome/free-solid-svg-icons";
import { useRallyData } from '../../../hooks/useRallyData';
import useMatchMeta from '../../../hooks/useMatchMeta';
import { extractVideoFileName, extractMatchIdFromFilename } from '../../../utils/rallyDataUtils';

export default function ReviewFeedback() {
  const { postId: videoId } = useParams();
  const navigate = useNavigate();
  const env = process.env.REACT_APP_ENV;
  const videoRef = useRef(null);
  const userId = localStorage.getItem("BQS__ID");
  const playerRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [drawing, setDrawing] = useState(false);
  const videoContent = useSelector((state) => state.video.videoContent);
  const jwtToken = localStorage.getItem("BQS_TOKEN");
  const [videoDimensions, setVideoDimensions] = useState({});
  const standAloneFeedbacks = useSelector(
    (state) => state.standAlone.feedbacks.feedbackData
  );
  const [annotations, setAnnotations] = useState([]);
  const firstname = localStorage.getItem("firstname");
  const lastname = localStorage.getItem("lastname");
  const [videoKey, setVideoKey] = useState(Date.now());
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const reviewPostId = localStorage.getItem('reviewPostId');
  const [data, setData] = useState(JSON.parse(localStorage.getItem(`${reviewPostId}_reviewPost`)));
  const reviewPost = JSON.parse(localStorage.getItem(`${reviewPostId}_reviewPost`));
  const [videoThumbnails, setVideoThumbnails] = useState({});
  const thumbnailUrl = videoThumbnails[videoId];
  // const thumbnailUrl = videoThumbnails[videoId] || "https://www.fisu.net/app/uploads/2023/09/badminton.jpg";
  const dispatch = useDispatch();
  const [frameRate, setFrameRate] = useState(30);
  const [playingAudioId, setPlayingAudioId] = useState(null);
  const location = useLocation();
  const rawVideoTags = location.state?.videoTags;
  const videoTagList = useMemo(() => {
    const locationTags = Array.isArray(rawVideoTags) ? rawVideoTags : [];
    const storedTags = Array.isArray(reviewPost?.tags) ? reviewPost.tags : [];
    const localDataTags = Array.isArray(data?.tags) ? data.tags : [];
    const merged = TagHelper.mergeTagLists(
      TagHelper.mergeTagLists(locationTags, storedTags),
      localDataTags
    );
    if (!reviewPostId) {
      return merged;
    }
    const keyPath = reviewPost?.game?.[0]?.path || data?.game?.[0]?.path;
    const persisted = TagHelper.getPersistedTags(reviewPostId, keyPath);
    return TagHelper.mergeTagLists(merged, persisted);
  }, [rawVideoTags, reviewPost, data, reviewPostId]);
  const { postId } = useParams();
  const [isDownloading, setIsDownloading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const isMatchVideo = useMemo(() => {
    return Array.isArray(videoTagList) && videoTagList.some(tag => {
      const name = typeof tag === 'string' ? tag : (tag?.tagName || tag?.name);
      return name?.toLowerCase() === "match video";
    });
  }, [videoTagList]);

  // Rally data hooks for SmartInsights integration
  const { fetchRallyData } = useRallyData();
  const { fetchMatchMeta } = useMatchMeta();
  const [loadingSmartInsights, setLoadingSmartInsights] = useState(false);

  const handleViewInSmartInsights = useCallback(async () => {
    try {
      setLoadingSmartInsights(true);

      const currentVideoUrl = localStorage.getItem("videoLinkInObjectStore");
      const videoPath = data?.game?.[0]?.path || currentVideoUrl;
      const videoFileName = extractVideoFileName(videoPath);
      const matchId = extractMatchIdFromFilename(videoFileName);

      let rallyData = null;
      let matchMeta = null;

      try {
        rallyData = await fetchRallyData(matchId, postId);
      } catch (rallyErr) {
        toast.warning('Could not load rally analysis data. Continuing with basic playback.');
      }

      try {
        matchMeta = await fetchMatchMeta(videoFileName);
      } catch (metaErr) {
        // Continue without metadata
      }

      // Get thumbnail
      let actualThumbnailUrl = videoThumbnails[videoId];
      if (!actualThumbnailUrl) {
        try {
          const tnPath = data?.game?.[0]?.tnPath || data?.tn?.[0]?.path;
          if (tnPath) {
            const token = localStorage.getItem('BQS_TOKEN');
            actualThumbnailUrl = await getFetchGamePostFileThumbnail(token, videoId, tnPath);
          }
        } catch { }
      }

      const videoDataToStore = {
        postId: postId || data?._id || videoId,
        videoUrl: videoPath,
        videoTitle: videoFileName ? videoFileName.split('.')[0] : 'Unknown Title',
        thumbnailUrl: actualThumbnailUrl || 'https://www.fisu.net/app/uploads/2023/09/badminton.jpg',
        rallyData,
        matchMeta,
      };

      const storageKey = `RALLY_DATA_${matchId}`;
      localStorage.setItem(storageKey, JSON.stringify(rallyData));
      sessionStorage.setItem('PG_DIRECT_LOAD', '1');
      sessionStorage.setItem('PG_DIRECT_VIDEO_DATA', JSON.stringify(videoDataToStore));

      navigate('/SmartInsights');
    } catch (err) {
      toast.error('Failed to open SmartInsights. Please try again.');
    } finally {
      setLoadingSmartInsights(false);
    }
  }, [fetchRallyData, fetchMatchMeta, postId, data, videoId, videoThumbnails, navigate]);


  const handleReportButtonClick = (event) => {
    if (isMatchVideo) {
      setAnchorEl(event.currentTarget);
    } else {
      downloadPDF('summary');
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = (type) => {
    downloadPDF(type);
    handleClose();
  };


  // Removed restrictive report gaters to match staging behavior


  const dataFormatter = (dateString) => {
    if (!dateString) return "";
    const inputDate = new Date(dateString);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const day = inputDate.getDate();
    const monthIndex = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();

    return `${day} ${monthNames[monthIndex]} ${year} at ${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  };


  const videoUrl = localStorage.getItem("videoLinkInObjectStore");
  const updatedAt = reviewPost?.updatedAt;
  const videoTitle = videoUrl ? videoUrl.split('/').pop() : "Unknown Title";

  const formattedTitleDate = `${videoTitle} - ${dataFormatter(updatedAt)}`;

  useEffect(() => {
    if (data !== null && jwtToken && env !== "standalone") {
      const fetchThumbnail = async (reviewPostId, tnPath) => {
        try {
          const thumbnailUrl = await getFetchGamePostFileThumbnail(
            jwtToken,
            reviewPostId,
            tnPath
          );
          setVideoThumbnails((prev) => ({
            ...prev,
            [reviewPostId]: thumbnailUrl,
          }));
        } catch (error) {
          console.error("Error fetching thumbnail:", error);
        }
      };

      fetchThumbnail(data._id, data?.game?.[0]?.tnPath);

    }
  }, [data, jwtToken, userId]);

  useEffect(() => {
    // Optimization: Skip blob fetching and use direct URL for streaming
    const videoUrl = localStorage.getItem("videoLinkInObjectStore");

    if (videoUrl) {
      console.log("🎬 Using direct video URL for streaming (Review):", videoUrl);
      dispatch(success_GetFetchVideoContent(videoUrl));
      setVideoKey(Date.now());
      setVideoLoaded(true);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [videoId, dispatch, jwtToken]);



  const userRole = localStorage.getItem("BQS_ROLE");

  const handleAudioPlay = (audioElement, annotation) => {
    // Pause video if playing
    if (playerRef.current) {
      playerRef.current.pause();
    }

    // Pause any other playing audio
    document.querySelectorAll('audio').forEach(audio => {
      if (audio !== audioElement) {
        audio.pause();
      }
    });

    setPlayingAudioId(annotation._id);

    // Add ended event listener to reset playingAudioId
    audioElement.addEventListener('ended', () => {
      setPlayingAudioId(null);
    });
  };


  const downloadPDF = async (reportType = 'summary') => {
    setIsDownloading(true);

    try {
      const response = await fetch(
        `${GET_INDIVIDUAL_REPORT}/${postId}/reports`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify(
            reportType === "detailed"
              ? { type: "detailed report" }
              : { type: "summary" }
          ),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("Success:", responseData);

      const url =
        responseData?.data?.data?.url ||
        responseData?.data?.url ||
        responseData?.url;

      if (url) {
        // This will open the URL in a new tab without getting blocked
        window.open(url, "_blank");
        toast.success("Report opened in a new tab!");
      } else {
        toast.error("Report URL not found.");
      }

    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download report.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (

    <section className="mb-8 pt-24 font-sans px-4 sm:px-6 lg:px-8">

      <div className="max-w-[1600px] mx-auto space-y-8">
        <div className="flex flex-col gap-0.5 mb-6 px-1">
          {/* Breadcrumbs */}
          <div className="flex items-center gap-2 text-xs text-gray-500 font-medium mb-1">
            <FontAwesomeIcon icon={faVideo} className="text-gray-400" />
            <span className="hover:text-emerald-600 transition-colors cursor-pointer" onClick={() => navigate(-1)}>My Reviews</span>
            <FontAwesomeIcon icon={faChevronRight} className="text-[10px] text-gray-300" />
            <span className="text-gray-900 font-bold">Reviewing Feedback</span>
          </div>

          <div className="space-y-1">
            {/* Title */}
            <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight leading-tight">
              {videoUrl ? videoUrl.split('/').pop().split('.')[0] : "Unknown Title"}
            </h1>

            <button
              disabled={isDownloading || videoContent?.isStartedvideoContent}
              onClick={handleReportButtonClick}
              className={`
                flex items-center gap-2 px-6 py-3 rounded-xl font-semibold shadow-lg transition-all duration-300 transform hover:scale-105
                ${isDownloading
                  ? 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-none'
                  : 'bg-gradient-to-r from-[#247E45] to-[#026B33] text-white hover:shadow-emerald-500/30'}
              `}
            >
              <Download size={18} />
              {isDownloading ? 'Downloading...' : 'Get Report'}
            </button>
          </div>
        </div>

        {/* Main Content Grid - Modern & Cinematic */}
        {/* Main Content Grid - Modern & Cinematic */}
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden flex flex-col lg:flex-row lg:h-[calc(100vh_-_280px)] lg:max-h-[calc(100vh_-_280px)] h-auto">
          {/* Left: Video Player Section */}
          <div className="flex-1 bg-black relative flex items-center justify-center group z-10">
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent pointer-events-none z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            <div className="w-full h-full relative z-20 aspect-video lg:aspect-auto">
              <VideoPlayer
                videoId={videoId}
                currentTime={currentTime}
                videoLoaded={videoLoaded}
                videoContent={videoContent}
                annotations={annotations}
                setAnnotations={setAnnotations}
                setLoading={setLoading}
                setVideoLoaded={setVideoLoaded}
                setVideoKey={setVideoKey}
                setFrameRate={setFrameRate}
                setCurrentTime={setCurrentTime || (() => { })}
                setVideoDimensions={setVideoDimensions}
                thumbnailUrl={thumbnailUrl}
                playerRef={playerRef}
                videoRef={videoRef}
                standAloneFeedbacks={standAloneFeedbacks}
                frameRate={frameRate}
                isPaused={isPaused}
                getCoachFeedback={getCoachFeedback}
                videoKey={videoKey}
                isPlayerSide={userRole === 'player'}
              />
            </div>

            <AnnotationStage
              videoRef={videoRef}
              annotations={annotations}
              isPaused={isPaused}
              playerRef={playerRef}
              videoDimensions={videoDimensions}
              isPlayerSide={userRole === 'player'}
            />
          </div>

          {/* Right: Sidebar (Details & Actions) */}
          <div className="w-full lg:w-96 bg-gray-50 border-l border-gray-200 flex flex-col shrink-0 z-0 h-[600px] lg:h-auto">

            {/* Tags Section */}
            <div className="p-5 border-b border-gray-200 bg-white/50 backdrop-blur-sm sticky top-0 z-10">
              <div className="mb-2 flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                <h4 className="text-xs font-bold uppercase tracking-wider text-gray-400">Video Tags</h4>
              </div>
              <GameVideoDetails videoTagList={videoTagList} />
            </div>

            {/* Feedback List (Scrollable) */}
            <div className="flex-1 overflow-y-auto bg-gray-50/30 relative scrollbar-thin scrollbar-thumb-gray-200 flex flex-col">
              {/* Sticky Header */}
              <div className="sticky top-0 bg-white/95 backdrop-blur-sm z-10 px-4 pt-4 pb-2 border-b border-gray-200 shadow-sm">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                    Feedback List
                  </h3>
                  <span className="text-xs font-medium text-gray-400 bg-gray-100 px-2 py-1 rounded-full border border-gray-200">
                    {annotations?.length || 0} items
                  </span>
                </div>
              </div>

              {/* Scrollable Content */}
              <div className="flex-1 p-4 pt-1">
                <FeedbackList
                  annotations={annotations}
                  videoContent={videoContent}
                  handleAudioPlay={handleAudioPlay}
                  currentTime={currentTime}
                  showClearButton={false}
                  hideHeader={true}
                  onFeedbackClick={(time) => {
                    if (playerRef.current) {
                      playerRef.current.currentTime(time);
                      playerRef.current.play();
                    }
                  }}
                  videoRef={videoRef}
                  setAnnotations={setAnnotations}
                  videoId={videoId}
                />
              </div>
            </div>

            {/* Actions Footer */}
            <div className="p-4 border-t border-gray-200 bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-20 flex flex-col gap-2">
              {/* View in SmartInsights - Match Videos only */}
              {isMatchVideo && (
                <button
                  type="button"
                  onClick={handleViewInSmartInsights}
                  disabled={loadingSmartInsights}
                  className={`
                    w-full flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-bold shadow-md text-sm transition-all duration-300 transform hover:-translate-y-0.5
                    bg-white border border-emerald-300 text-emerald-700 hover:bg-emerald-50 hover:shadow-emerald-200
                    disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0
                  `}
                  title="Open this match in SmartInsights Playground"
                >
                  {loadingSmartInsights ? (
                    <div className="w-4 h-4 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <FontAwesomeIcon icon={faBolt} />
                  )}
                  {loadingSmartInsights ? 'Loading...' : 'View in SmartInsights'}
                </button>
              )}
              <button
                disabled={isDownloading || videoContent?.isStartedvideoContent}
                onClick={handleReportButtonClick}
                className={`
                      w-full flex items-center justify-center gap-2 px-6 py-4 rounded-xl font-bold shadow-lg text-sm uppercase tracking-wider transition-all duration-300 transform hover:-translate-y-1
                      ${isDownloading
                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-none'
                    : 'bg-gradient-to-r from-[#247E45] to-[#026B33] text-white shadow-emerald-500/20 hover:shadow-emerald-500/40'}
                    `}
              >
                <Download size={20} />
                {isDownloading ? 'Downloading Report...' : 'Get Analysis Report'}
              </button>
            </div>
          </div>
        </div>

        {/* Closing Feedback */}
        <div className="pb-12">
          <CoachClosingFeedback readOnly={true} videoTagList={videoTagList} />
        </div>
      </div>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            marginTop: '8px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: '1px solid #f3f4f6',
            '& .MuiMenuItem-root': {
              fontSize: '0.875rem',
              fontWeight: 500,
              padding: '10px 16px',
              color: '#374151',
              '&:hover': {
                backgroundColor: '#f0fdf4',
                color: '#059669',
              },
            },
          },
        }}
      >
        <MenuItem onClick={() => handleDownload('summary')}>Summary Report</MenuItem>
        <MenuItem onClick={() => handleDownload('detailed')}>Detailed Report</MenuItem>
      </Menu>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="rounded-xl shadow-lg border border-gray-100 font-sans"
      />
    </section >
  );
}
